import { render, staticRenderFns } from "./DiscussHotVirtualList.vue?vue&type=template&id=01fc3332&"
import script from "./DiscussHotVirtualList.vue?vue&type=script&lang=js&"
export * from "./DiscussHotVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports